import { ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED } from './all-classes-actions';

const initialState = null;

/**
 * Activity Mastery - All Classes Reducer
 *
 * Consumes ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED:
            return action.payload;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/activity-mastery/all-classes/all-classes-reducer.js